<template>
    <div>
        <el-row :gutter="15">
            <el-col :sm="24" :md="24">
                <p>
                    Your submission was saved successfully. Your form reference
                    id is <strong>{{ formId }}</strong
                    >.
                </p>
                <div v-if="paymethod == 'bank'">
                    After we receive your submission and check all materials an
                    invoice will be sent to your email. Please forward at
                    <a href="mailto:konstadina@europeanarch.eu"
                        >konstadina@europeanarch.eu</a
                    >
                    the bank transfer receipt adding the ID of your entry as
                    reference number.<BR />
                    <a
                        class="bankdocument"
                        href="https://awardapplication.com/pdf/Bank_Transfer_E40U40.pdf"
                        target="_blank"
                        >Download Bank payment details</a
                    >
                </div>
                <div v-else>
                    After we receive your submission and check all materials an
                    invoice will be sent to your email.
                </div>

                <p>
                    If you wish to apply for more than one projects to our award
                    program, please return to the
                    <a href="https://awardapplication.com/"
                        >AWARD APPLICATION HOME page</a
                    >.
                </p>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        formId: String | Number,
        paymethod: String,
    },
    data: () => ({}),
    methods: {
        refreshPage: function () {
            window.location.reload();
        },
    },
};
</script>
